import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './webportal/components/root/App';
import './index.css';
import * as Promise from 'bluebird';

Promise.config({
    warnings: false
});

ReactDOM.render(
    <App />,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx